module.exports = __webpack_public_path__ + "static/media/club_icon_red.9cb07b49.svg";